var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from "lodash/get";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { dispatchEvent, trackLinks } from "../../utils/analytics";
import { GlobalProvider } from "../Context";
import ErrorBoundary from "../Error";
import ThemeProvider, { defaultTheme } from "../ThemeProvider";
import { attTheme } from "../ThemeProvider/att";
import { cricketTheme } from "../ThemeProvider/cricket";
import { sprintTheme } from "../ThemeProvider/sprint";
import { staplesTheme } from "../ThemeProvider/staples";
import { verizonTheme } from "../ThemeProvider/verizon";
import components from "./components";
import { MainWrapper } from "./MainWrapper";
var getVendorTheme = function (vendor) {
    switch (vendor) {
        case "verizon":
            return verizonTheme;
        case "sprint":
            return sprintTheme;
        case "att":
            return attTheme;
        case "staples":
            return staplesTheme;
        case "cricket":
            return cricketTheme;
        default:
            return null;
    }
};
var renderComponent = function (component, graphQLResponse) {
    var componentType = !graphQLResponse
        ? get(component, "sys.contentType.sys.id")
        : get(component, "__typename");
    var Element = componentType && components.get(componentType);
    if (!Element) {
        throw new Error("unknown component type " + componentType);
    }
    var fields = !graphQLResponse ? __assign({}, component.fields) : __assign({}, component);
    return (React.createElement(Element, __assign({ key: component.sys.id, graphQLResponse: graphQLResponse }, fields)));
};
var ArticleComposer = /** @class */ (function (_super) {
    __extends(ArticleComposer, _super);
    function ArticleComposer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            articleId: "",
            articleTitle: "",
        };
        return _this;
    }
    ArticleComposer.prototype.componentDidMount = function () {
        var _a = this.props, graphQLResponse = _a.graphQLResponse, response = _a.response;
        var articleTitle = !graphQLResponse
            ? get(response, "fields.title")
            : get(response, "title");
        var articleId = !graphQLResponse
            ? get(response, "sys.id")
            : get(response, "id");
        var properties = {
            articleTitle: articleTitle,
            articleId: articleId,
            source: this.props.source || "global",
        };
        this.setState({
            articleId: properties.articleId,
            articleTitle: properties.articleTitle,
        }, function () {
            dispatchEvent("Viewed_Article", properties);
            trackLinks(properties);
        });
    };
    ArticleComposer.prototype.render = function () {
        var _a = this.props, response = _a.response, _b = _a.vendor, vendor = _b === void 0 ? "asurion" : _b, _c = _a.graphQLResponse, graphQLResponse = _c === void 0 ? false : _c, _d = _a.withCSSReset, withCSSReset = _d === void 0 ? true : _d, _e = _a.source, source = _e === void 0 ? "global" : _e;
        var _f = this.state, articleId = _f.articleId, articleTitle = _f.articleTitle;
        var articleContent = !graphQLResponse
            ? get(response, "fields.articleContent")
            : get(response, "articleContentCollection").items;
        var theme = getVendorTheme(vendor)
            ? getVendorTheme(vendor)
            : defaultTheme;
        return (React.createElement(GlobalProvider, { vendor: vendor, article: { articleId: articleId, articleTitle: articleTitle, source: source } },
            React.createElement(ThemeProvider, { withReset: withCSSReset, theme: getVendorTheme(vendor) },
                React.createElement(MainWrapper, { theme: theme },
                    React.createElement(ErrorBoundary, null, articleContent.map(function (component, index) {
                        return renderComponent(component, graphQLResponse);
                    }))))));
    };
    return ArticleComposer;
}(Component));
// @ts-ignore
ArticleComposer.defaultProps = {
    source: "global",
};
// @ts-ignore
ArticleComposer.propTypes = {
    response: PropTypes.any.isRequired,
    vendor: PropTypes.oneOf([
        "asurion",
        "verizon",
        "att",
        "cricket",
        "sprint",
        "agnostic",
        "staples",
    ]).isRequired,
    graphQLResponse: PropTypes.bool,
};
export default ArticleComposer;
